/*
|-------------------------------------------------------------------------------
| Services for General Axios Endpoint Queries
|-------------------------------------------------------------------------------
*/
import axios from "axios";
import * as helpers from "../../utilities/helperUtils";

let baseUrl = window.location.origin;
let strapiUrl = "";
if (baseUrl.includes("develop")) {
    strapiUrl = "https://devstrapi.hermertiawars.com"
} else if (baseUrl.includes("hermertiawars.com") && !baseUrl.includes("develop")) {
    strapiUrl = "https://strapi.hermertiawars.com"
} else {
    strapiUrl = helpers.getEnvironmentVar("VUE_APP_STRAPI_URL", "");
}

const instance = axios.create({
  baseURL: helpers.getEnvironmentVar("VUE_APP_BASE_URL", "") + "/be/"
});

const strapiInstance = axios.create({
  baseURL: strapiUrl
});

export { instance, strapiInstance };
